import React from "react";

const features = [
  {
    title: "Unified Knowledge Graph",
    description:
      "Access billions of biomedical relationships through a single API. Compounds, targets, diseases, pathways, publications, and patents are all cross-linked in one queryable graph.",
    icon: "fi fi-rr-chart-network",
  },
  {
    title: "Multi-Source Intelligence",
    description:
      "Plex aggregates and harmonizes data from ChEMBL, UniProt, PubChem, KEGG, patent databases, and biomedical literature. No more stitching APIs together.",
    icon: "fi fi-rr-database",
  },
  {
    title: "Chemical Similarity Search",
    description:
      "Run Tanimoto, substructure, and semantic similarity searches across millions of compounds. Tunable thresholds and fingerprint methods give you precise control.",
    icon: "fi fi-rr-search",
  },
  {
    title: "AI-Powered Analysis",
    description:
      "Built-in LLM integration lets agents reason over structured search results. Use the chat API or connect via MCP to let Claude, ChatGPT, or Gemini query Plex directly.",
    icon: "fi fi-rr-brain",
  },
];

const WhyPlex = () => (
  <section id="why-plex" className="developer-section">
    <h2>Why Plex?</h2>
    <p>
      Drug discovery and biomedical research require connecting information across dozens of siloed databases.
      Plex eliminates that fragmentation by providing a single, unified API that lets you traverse
      the entire biomedical knowledge landscape.
    </p>
    <div className="dev-feature-grid">
      {features.map(f => (
        <div key={f.title} className="dev-feature-card">
          <div className="dev-feature-icon">
            <i className={f.icon} />
          </div>
          <h3>{f.title}</h3>
          <p>{f.description}</p>
        </div>
      ))}
    </div>
  </section>
);

export default WhyPlex;
